import { combineReducers } from "redux";
import Detail from "./Detail/Reducer.js";

export default combineReducers({
    Detail
});